import { render, staticRenderFns } from "./SiderBar.vue?vue&type=template&id=d73a9de2&scoped=true&"
import script from "./SiderBar.vue?vue&type=script&lang=js&"
export * from "./SiderBar.vue?vue&type=script&lang=js&"
import style0 from "./SiderBar.vue?vue&type=style&index=0&id=d73a9de2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d73a9de2",
  null
  
)

export default component.exports